module.exports = __webpack_public_path__ + "static/media/ssc-tb.763def18.woff";